import React from 'react';
/* import { getTagAction } from './analytics'; */

/* onClick={() => getTagAction('Seguro Salud Flexible', 'Interacciones', 'Clic', 'Conoce más')} */

const stepHome = {
  heroSection: {
    subtitle: 'SEGURO SALUD FLEXIBLE',
    title: 'Creado para ti y tu familia',
    description: (
      <>
        <b>Arma, cotiza y compra 100% online. </b>
        Ingresa tus datos para comenzar:
      </>
    ),
    privacyLabel: (
      <>
        Al continuar acepto las
        <a
          rel="noopener noreferrer"
          href="https://www.rimac.com/politica-privacidad"
          target="_blank"
        >
          Políticas de Privacidad
        </a>
      </>
    ),
    commercialLabel: 'Acepto la',
    comercialSpan: 'Política Comunicaciones Comerciales',
    buttonLabel: 'Cotiza aquí',
    toBenefitsButtonLabel: 'Conoce tus beneficios',
    fixedButtonTooltip: 'VER BENEFICIOS',
  },
  forYouSection: {
    title: 'Un seguro creado para ti',
    actionButtonLabel: 'Quiero cotizar',
    benefits: [
      {
        title: 'Te ofrecemos dos Planes base',
        description: 'Seguro en casa o Seguro en casa y clínica. Puedes elegir cualquiera de los dos según tus necesidades.',
      },
      {
        title: 'Te garantizamos protección',
        description: 'Nuestras coberturas adicionales ofrecen hospitalización, emergencias accidentales cubiertas al 100%, ambulancias y más.',
      },
      {
        title: 'Te acompañamos siempre',
        description: 'Puedes usar los servicios de videoconsulta y orientación telefónica desde el día uno.',
      },
    ],
  },
  questionSection: {
    title: 'Preguntas frecuentes',
    questions: [
      {
        title: '¿Qué es el seguro Salud Flexible?',
        description: '¡Es un seguro creado por ti y para ti! Puedes armarlo de acuerdo a tus necesidades y las de tu familia. Solo tienes que elegir uno de nuestros planes base: Seguro en casa o Seguro en casa y clínica, y agregar las coberturas que desees.',
      },
      {
        title: '¿Dónde puedo atenderme?',
        description: 'Si tu plan es Seguro en casa y clínica, puedes atenderte en más de 300 clínicas a nivel nacional pagando S/40 por consulta. Asimismo, tus medicamentos y exámenes derivados de la consulta estarán cubiertos en un 70%. Si elegiste el plan Seguro en casa, tus atenciones siempre serán desde la comodidad de tu hogar. Puedes acceder a un médico a domicilio pagando S/40 por consulta.',
      },
      {
        title: '¿Cuánto tiempo debo esperar para hacer uso de mi seguro?',
        description: 'Te protegemos desde el primer día a través de la cobertura de videoconsulta y orientación telefónica. Estos beneficios están incluidos en nuestros dos planes. Ten en cuenta que el periodo de carencia para nuestros planes es de 30 días y el periodo de espera para usar las coberturas varía porque depende cuál sea esta.',
      },
    ],
  },
};

const stepPlans = {
  pagePlans: {
    backButtonLabel: 'Volver',
    title: 'Elige tu plan base',
    dropdownTitle: 'Precios calculados para:',
    addInsuredButtonLabel: 'Agrega familiares a tu cotización',
    planInfo: 'Los precios de cada plan están calculados de acuerdo a tu edad.',
  },
  noCoverageSection: {
    titleSection: 'Qué es lo que no cubre',
    info: 'Podrás ver el listado completo en la póliza de tu seguro',
    list: [
      'Trastornos o problemas de aprendizaje o lenguaje.',
      'Afectaciones o lesiones por uso de drogas, fármacos o alcohol no diagnosticadas por un médico.',
      'Embarazo, maternidad, sus complicaciones y consecuencias cuando no se ha comprado la cobertura adicional de Hospitalización y Maternidad.',
      'Consecuencias de negligencias en su rehabilitación y automedicación.',
    ],
  },
};

const header = {
  titleLeft: '¡Compra por este medio!',
  telephone: '411 6001',
};

const tyPage = {
  pageTY: {
    title: '¡Muy bien! Estamos listos para proteger tu salud',
    description: 'Enviaremos a tu correo registrado la confirmación de compra de tu <span>[PLAN_SELECTED].</span>',
    keepSub: 'Ten en cuenta lo siguiente:',
    keepList: [
      {
        id: 1,
        text: (
          <>
            Considera los tiempos de espera y carencia antes de utilizar tu póliza.
            {' '}
          </>
        ),
        modalLink: true,
      },
      {
        id: 2,
        text: (
          <>
            Aún necesitamos verificar algunos datos para emitir tu póliza.
            {' '}
            La enviaremos al correo indicado máximo en 3 días hábiles.
          </>
        ),
      },
      {
        id: 3,
        text: (
          <>
            Comunícate al
            {' '}
            <b>
              (01) 411 1111
            </b>
            , si no recibes tu póliza en este periodo.
          </>
        ),
      },
    ],
  },
};

const errorPage = {
  title: '¡Gracias por confiar en nosotros!',
  subtitle: `Para continuar tu compra, te asignaremos un asesor especializado
  que se pondrá en <strong>contacto contigo.</strong>`,
  listText: ['Horario de contacto:', 'Lunes a viernes de 8 a.m. a 9 p.m.', 'Sábados de 8 a.m. a 2 p.m'],
  advice: 'Si deseas también puedes contactarnos:',
  btnText: 'Ir a Salud RIMAC',
  telephone: '(01) 411-6001',
};

const errorCustomPage = {
  title: ', queremos brindarte una atención personalizada',
  title2: 'Queremos brindarte una atención personalizada',
  subtitle: 'Un asesor se comunicará contigo cuanto antes para ofrecerte una mejor experiencia.',
  listText: ['Horario de contacto:', 'Lunes a viernes de 8 a.m. a 9 p.m.', 'Sábados de 8 a.m. a 2 p.m'],
  advice: 'Si deseas también puedes contactarnos:',
  btnText: 'Ir a Salud RIMAC',
  telephone: '(01) 411-6001',
};

const errorService = {
  title: '¡Algo falló! Hubo un error en el sistema',
  subtitle: 'Si tu actual estado de salud no te lo permite, te invitamos a a revisar los demás productos que tenemos para ti',
  btnText: 'Ver más seguros',
};

const errorPayment = {
  title: '¡Ups! Tenemos problemas para procesar tu pago',
  subtitle: 'Por favor, regresa al paso inicial para volver a intentarlo.',
  btnText: 'Volver a empezar',
};

export {
  stepHome,
  stepPlans,
  header,
  tyPage,
  errorPage,
  errorCustomPage,
  errorService,
  errorPayment,
};
